import settings from 'src/core/config/hostConfig'

const isURLRegexp = new RegExp("^/([a-z0-9\\-._~%!$&'()*+,;=:@/]*)")

const baseProxy = (value: string, serviceURL: string) => {
  let url = value
  // settings.proxy use for run tests in jenkins.
  // app-designer block our requests if we make it by app-designer url
  if (!settings.proxy && isURLRegexp.test(value)) {
    url = serviceURL + url
  }

  return url
}

export const proxy = (value: string) => {
  return baseProxy(value, settings.dataServerUrl)
}

export const proxyIdentity = (value: string) => {
  return baseProxy(value, settings.identityService || settings.dataServerUrl)
}

export const proxySiteBuilder = (value: string) => {
  return baseProxy(value, settings.sitebuilderService || settings.dataServerUrl)
}

export const proxyChatMessage = (value: string) => {
  return baseProxy(value, settings.chatMessageService || settings.dataServerUrl)
}

export const proxyLov = (value: string) => {
  return baseProxy(value, settings.lovService || settings.dataServerUrl)
}

export const proxyFileUpload = (value: string) => {
  return baseProxy(value, settings.fileUploadService || settings.dataServerUrl)
}
